<template>
    <v-row>
        <v-col cols="auto" class="pr-0">
            <image-popup :src="src" :size="size" :rounded="rounded" />
        </v-col>
        <v-col><v-file-input v-model="file" :label="label" accept="image/*" v-bind="attrs_input"/></v-col>
    </v-row>
</template>

<script>
import ImagePopup from "./image-popup.vue";
const attrs_input = {
    dense: true,
    outlined: true,
    persistentPlaceholder: true,
    "hide-details": true,
};
export default {
    components: { ImagePopup },
    props: {
        value: { type: File, default: null },
        size: { type: String, default: "40" },
        rounded: { type: Boolean, default: false },
        label: { type: String, default: "이미지" },
        imageSrc: { type: String, default: undefined },
    },
    computed: {
        isOutSync() {
            if (this.value || this.file) return this.value != this.file;
            else return false;
        },
        src() {
            if (this.file) return URL.createObjectURL(this.file);
            else return this.imageSrc;
        },
    },
    data() {
        return {
            file: null,
            attrs_input,
        };
    },
    methods: {
        init() {
            this.file = this.value;
        },
        emit() {
            this.$emit("input", this.file);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            if (this.isOutSync) this.init();
        },
        file() {
            if (this.isOutSync) this.emit();
        },
    },
};
</script>

<style></style>
